@use "styles" as *;

.me-expander {
  display: block;

  &__content {
    overflow: hidden;
    mask-image: linear-gradient(180deg, black 50%, transparent 100%);
    mask-size: 100% 200%;

    @include remove-first-and-last-child-margins;
  }

  &--animated &__content {
    transition: all $transition-timing;
  }

  &--expandable &__content {
    mask-size: 100% 100%;
  }

  &--expanded &__content {
    mask-size: 100% 200%;
  }
}
